import { initializeApp } from "firebase/app";
import {
  getFirestore,
  doc,
  getDoc,
  setDoc,
  onSnapshot,
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDvs8ErJlXRYRgsntcFljb26I42efyXrNQ",
  authDomain: "istarai-21763.firebaseapp.com",
  projectId: "istarai-21763",
  storageBucket: "istarai-21763.firebasestorage.app",
  messagingSenderId: "697051093373",
  appId: "1:697051093373:web:ac196b99ac1f88e8b91414",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

// ── Firestore 讀寫工具函式 ──────────────────────────────────
// 資料結構：
//   專案資料  → /projects/{proj}/data/{key}
//   系統資料  → /system/{key}
//   使用者帳號 → /system/users

export async function fsGet(proj, key, def) {
  try {
    const ref =
      proj === "_global"
        ? doc(db, "system", key)
        : doc(db, "projects", proj, "data", key);
    const snap = await getDoc(ref);
    return snap.exists() ? snap.data().value : def;
  } catch (e) {
    console.error("fsGet error", e);
    return def;
  }
}

export async function fsSet(proj, key, value) {
  try {
    const ref =
      proj === "_global"
        ? doc(db, "system", key)
        : doc(db, "projects", proj, "data", key);
    await setDoc(ref, { value });
  } catch (e) {
    console.error("fsSet error", e);
  }
}

export async function fsGetUsers() {
  try {
    const ref = doc(db, "system", "users");
    const snap = await getDoc(ref);
    return snap.exists() ? snap.data().value : null;
  } catch (e) {
    console.error("fsGetUsers error", e);
    return null;
  }
}

export async function fsSaveUsers(users) {
  try {
    await setDoc(doc(db, "system", "users"), { value: users });
  } catch (e) {
    console.error("fsSaveUsers error", e);
  }
}

export function fsListen(proj, key, callback) {
  const ref =
    proj === "_global"
      ? doc(db, "system", key)
      : doc(db, "projects", proj, "data", key);
  return onSnapshot(ref, (snap) => {
    if (snap.exists()) callback(snap.data().value);
  });
}
